// TwoLineCell — primary/secondary text stack for a table or list cell
// (title + subtitle, single-line ellipsis each). i18n-clean: `primary`/
// `secondary`/`title` arrive via props; imports only from `./` (none needed).
import type { CSSProperties, ReactNode } from 'react';

export interface TwoLineCellProps {
  primary: ReactNode;
  secondary?: ReactNode;
  title?: string;
}

const ELLIPSIS: CSSProperties = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export function TwoLineCell({ primary, secondary, title }: TwoLineCellProps) {
  return (
    // WHY: minWidth:0 lets the ellipsis rules win inside a flex/table cell
    // that would otherwise let this block grow to its content's width.
    <div style={{ minWidth: 0 }} title={title}>
      <div style={{ ...ELLIPSIS, fontSize: 14, fontWeight: 500, color: 'var(--fg-1)' }}>
        {primary}
      </div>
      {secondary !== undefined && (
        <div style={{ ...ELLIPSIS, fontSize: 12, color: 'var(--fg-3)' }}>{secondary}</div>
      )}
    </div>
  );
}
